<template>
  <div class="basket" ref="container">
    <q-resize-observer @resize="onResize"/>

    <template v-if="basketItemsRoot.length">

      <div class="q-px-md q-px-md-none q-px-lg-md q-pt-sm">

        <TransitionGroup name="slide-fade" tag="div" class="q-gutter-y-md">
          <BasketItem
              v-for="item in basketItemsRoot"
              :item="item"
              :key="item.id"
          />
        </TransitionGroup>

        <!-- Basket Rules Gifts Display -->
        <div class="q-mt-xs q-gutter-y-xs" v-if="false">
          <!-- Обычный подарок -->
          <BasketRulesGifts :is-additional="false"/>

          <!-- Дополнительный подарок -->
          <BasketRulesGifts :is-additional="true"/>
        </div>

      </div>

      <div class="q-gutter-y-md q-pt-sm q-px-md q-px-md-none q-px-lg-md" v-if="false">
        <div class="flex items-center">
          <div class="text-grey-8" v-if="basketWeight">
            <span class="s-font-2xs">Общий вес:</span>
            <span class="s-font-xs text-weight-bold q-ml-xs"
            >{{ basketWeight }}г</span>
          </div>
          <div class="q-ml-auto">
            <q-btn
                label="очистить"
                flat
                dense
                size="12px"
                color="red-8 q-mx-auto"
                :icon="ICONS.trush"
                class="--icon-same"
                @click="onClear"
            />
          </div>
        </div>
      </div>

      <BasketRulesProductsCarousel
          :products="basketRulesProducts"
          :items-to-show="specialCarouselSlidesCount + 0.23"
          class="q-mt-md"
          v-if="width"
          :style="{
            maxWidth: width + 'px'
          }"
      />

    </template>
    <template v-else>
      <div class="text-center s-font-sm q-my-md">в корзине пока нет товаров</div>
    </template>

  </div>
</template>

<script setup lang="ts">
import {ICONS} from "@/assets/icons";
import BasketRulesGifts from "@/components/Shop/VOrder/ui/BasketRulesGifts.vue";
import BasketRulesProductsCarousel from "@/components/Shop/VOrder/ui/BasketRulesProductsCarousel.vue";
import {useDebugComponent} from "@/core/composable/useDebugComponent";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";
import {useProductModificatorsComputedStore} from "@/modules/shop/store/product-modificators-computed";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {storeToRefs} from "pinia";
import {QResizeObserverProps, useQuasar} from "quasar";
import {computed, nextTick, ref, watch} from "vue";
import {useRouter} from "vue-router";
import BasketItem from "./ui/BasketItem/BasketItem.vue";

const $q = useQuasar();
const router = useRouter();

const props = withDefaults(
    defineProps<{
      specialCarouselSlidesCount?: number;
    }>(),
    {
      specialCarouselSlidesCount: 1,
    }
);

const {specialCarouselSlidesCount} = props;

const vorderStateStore = useVorderState();
const basketStore = useBasketStore();
const modificatorsComputedStore = useProductModificatorsComputedStore();
const basketRulesStore = useBasketRulesStore();


const {basketOp} = basketStore;
const {basketWeight, basketItemsRoot} = storeToRefs(basketStore);
const {attrs} = storeToRefs(vorderStateStore);

const width = ref(0)
const container = ref<HTMLElement | null>(null);

// Используем новый метод getProducts (ранее getUpsaleProducts)
const allSuggestions = computed(() => {
  return modificatorsComputedStore.getProducts({
    modActive: true,
    includeInactiveByPrice: true,
  });
});

// Товары из basket rules
const basketRulesProducts = computed(() => {
  return basketRulesStore.getProducts({
    ruleActive: true,
    includeInactiveByPrice: true,
    inBasket: false, // Только товары НЕ в корзине
  });
});


const onClear = () => {
  $q.dialog({
    title: "Очистить корзину?",
    cancel: "Отмена",
  }).onOk(() => {
    basketOp({action: "clear"});
  });
};

const openAvailableDialog = () => {
  router.push("/basket/available-modificators");
};

const openGlobalModificators = () => {
  router.push("/basket/global-modificators");
};

const onResize: QResizeObserverProps['onResize'] = (size) => {
  width.value = size.width
}

watch(() => $q.screen.width, async () => {
  await nextTick()
  width.value = 0
  await nextTick()
  if (container.value) {
    width.value = container.value.clientWidth
  }
})

// Debug композабл для отслеживания ререндеров
useDebugComponent('Basket', {collectRenders: true});


</script>

<style lang="scss" scoped>
.basket {
  --line-width: 1px;
  --line-color: #888888;
  --node-gutter-y: 10px;
}

.с-sections {
  background-color: #F8F8F8;
  border-radius: 14px;
  padding: 2px 0 0 0;
  overflow: hidden;;

  :deep() {
    .c-section:not(:last-child) {
      border-bottom: 1px solid #DDDDDD;
    }
  }
}


</style>
